<template>
    <div class="article-chuck-hero">
        <p>
            Chuck Brown (otherwise affectionately known as Chuckleberryfinn, Chuckynugget or ChuckieChan) and I met in
            Singapore whilst I was living and working there and he was there for an incredible event called Asia Open.
        </p>
        <p>
            Fast forward 5 years to 2022, I’ve just turned 30 and I have decided to get more stuck in with this west
            coast swing thing and dabble in teaching.
        </p>
        <p>
            Starting as a silent assistant at Neverland Swing and Summer Summit 2022 and being given the chance by so
            many other fabulous event directors to work with Chuck, we started to grow together as a partnership.
            Honestly, it’s been a whirlwind but the good kind, like cotton candy collecting on a stick.
        </p>
        <p>
            Where I come from, we have a saying, <strong>they fit together like chalk and cheese</strong> - I would say
            this is the best explanation for Chuck and me.
        </p>
    </div>
</template>

<script>
export default {
    name: 'ArticleChuckHero',
};
</script>
